import { Component } from 'react'
import _ from 'lodash'

import CategorySelector from './index'
import { CATEGORY_TYPE } from '../../../../../constants/proposalTypes'
import { Fields } from '../../../../Common/forms'
import { changeAndBlurInput, getInputValue } from '../../../../../lib/ReduxFormHelper'

class CategorySelectorField extends Component {
  /**
   * 改變 redux-form state 裡面 cat, catItemId, struDataAttrClusterId
   */
  handleAttrClusterChange = (selectedLeafOption = {}, allSelectedOptions = []) => {
    const [catOption, catItemOption] = allSelectedOptions

    const { product, triggerFieldChange } = this.props
    // fields from redux-form
    const {
      catId,
      catItemId,
      struDataAttrClusterId
    } = product

    const selectedCat = _.get(catOption, 'value', null)
    const selectedCatItem = _.get(catItemOption, 'value', null)
    const selectedCluster = _.get(selectedLeafOption, 'value', null)

    // 因為依序的 changeAndBlurInput 在 withAttributeTransient 組 transientField 欄位時
    // 會組合出錯誤的值
    // 所以先將 struDataAttrClusterId 設為 null 讓 transientFieldReady 為 false
    // 最後才設定 struDataAttrClusterId

    // *但* 不知道為什麼在透過 `選擇規格表` 來到這裡 (handleAttrClusterChange) 時
    // 不會有因為依序的 changeAndBlurInput 造成組出錯誤值的現象
    changeAndBlurInput(struDataAttrClusterId, null)

    changeAndBlurInput(catId, selectedCat)
    changeAndBlurInput(catItemId, selectedCatItem)

    // store structure data attribute cluster
    triggerFieldChange(
      'setting.struDataAttrCluster',
      _.get(selectedLeafOption, CATEGORY_TYPE.ATTR_CLUSTER, {})
    )

    changeAndBlurInput(struDataAttrClusterId, selectedCluster)
  }

  getFieldValues = () => {
    const {
      subStationId,
      product
    } = this.props

    const {
      catId,
      catItemId,
      struDataAttrClusterId
    } = product

    return {
      subStationId: getInputValue(subStationId),
      catId: getInputValue(catId),
      catItemId: getInputValue(catItemId),
      struDataAttrClusterId: getInputValue(struDataAttrClusterId)
    }
  }

  render () {
    const {
      readOnly,
      mismatchedCluster,
      phase,
      isPM,
      onRecentlyAttributesChange
    } = this.props

    const {
      subStationId,
      catId,
      catItemId,
      struDataAttrClusterId
    } = this.getFieldValues()

    // filter out fields related props
    const clusterError = _.get(this.props, 'product.struDataAttrClusterId.meta.error')
    const nextProps = _.pickBy(this.props, (p, k) => !/subStationId|product|names/.test(k))

    return (
      <CategorySelector
        key='selector'
        {...nextProps}
        readOnly={readOnly}
        mismatchedCluster={mismatchedCluster}
        phase={phase}
        isPM={isPM}
        subStationId={subStationId}
        catId={catId}
        catItemId={catItemId}
        struDataAttrClusterId={struDataAttrClusterId}
        onAttrClusterChange={this.handleAttrClusterChange}
        error={clusterError}
        onRecentlyAttributesChange={onRecentlyAttributesChange}
      />
    )
  }
}

const CATEGORY_FIELDS_NAMES = [
  'subStationId',
  'product.catId',
  'product.catItemId',
  'product.struDataAttrClusterId'
]
const CategorySelectorFields = props => (
  <Fields
    names={CATEGORY_FIELDS_NAMES}
    component={CategorySelectorField}
    {...props}
  />
)

export default CategorySelectorFields
